
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-16 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Privacy & Confidentiality Policy
            </h1>
            <p className="text-lg text-white/90">
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="bg-orange-50 border-l-4 border-orange-600 p-6 mb-8 rounded-r-lg">
                <p className="text-sm text-gray-700 leading-relaxed">
                  Digital Domination LLC ("we," "us," or "our") is committed to protecting your
                  privacy and maintaining the confidentiality of your personal information. This
                  Privacy & Confidentiality Policy explains how we collect, use, disclose, and
                  safeguard your information when you use our services or visit our website.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-information-line text-orange-600 mr-3"></i>
                  Information We Collect
                </h2>

                <div className="space-y-6">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      Personal Information
                    </h3>
                    <p className="text-sm text-gray-700 mb-3">
                      We may collect personal information that you voluntarily provide to us,
                      including:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Name, email address, phone number, and mailing address</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Business information and company details</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Payment and billing information</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Website login credentials and account information</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      Automatically Collected Information
                    </h3>
                    <p className="text-sm text-gray-700 mb-3">
                      When you visit our website, we may automatically collect certain information:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>IP address, browser type, and operating system</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Pages visited, time spent on pages, and navigation patterns</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Referring website addresses and search terms used</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Device information and unique identifiers</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Business Information</h3>
                    <p className="text-sm text-gray-700 mb-3">
                      In the course of providing our services, we may collect:
                    </p>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Marketing data and analytics information</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Website access credentials and hosting information</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Social media account information and advertising data</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>Customer and prospect data for marketing campaigns</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-settings-3-line text-orange-600 mr-3"></i>
                  How We Use Your Information
                </h2>
                <div className="bg-gray-50 rounded-lg p-6">
                  <p className="text-sm text-gray-700 mb-4">
                    We use the information we collect for the following purposes:
                  </p>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To provide, maintain, and improve our services</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To process transactions and send related information</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To communicate with you about services, updates, and promotions</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To respond to your inquiries and provide customer support</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To analyze usage patterns and improve our website and services</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To comply with legal obligations and protect our rights</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>To execute digital marketing campaigns on your behalf</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-shield-check-line text-orange-600 mr-3"></i>
                  Confidentiality Commitment
                </h2>
                <div className="bg-white border-2 border-orange-600 rounded-lg p-6">
                  <p className="text-sm text-gray-700 leading-relaxed mb-4">
                    <strong className="text-gray-900">
                      We take confidentiality seriously.
                    </strong>{' '}
                    All client information, business data, strategies, and proprietary information
                    shared with Digital Domination LLC will be treated as strictly confidential. We
                    will not disclose, share, or use your confidential information for any purpose
                    other than providing our agreed-upon services.
                  </p>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    Our team members and contractors are bound by confidentiality agreements and are
                    trained to handle sensitive information with the utmost care and discretion.
                  </p>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-share-line text-orange-600 mr-3"></i>
                  Information Sharing and Disclosure
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  We do not sell, trade, or rent your personal information to third parties. We may
                  share your information only in the following circumstances:
                </p>
                <div className="space-y-4">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Service Providers</h3>
                    <p className="text-sm text-gray-700">
                      We may share information with trusted third-party service providers who assist
                      us in operating our business (e.g., payment processors, hosting providers,
                      analytics services). These providers are contractually obligated to protect
                      your information.
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Legal Requirements</h3>
                    <p className="text-sm text-gray-700">
                      We may disclose information if required by law, court order, or governmental
                      regulation, or if we believe disclosure is necessary to protect our rights or
                      the safety of others.
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Business Transfers</h3>
                    <p className="text-sm text-gray-700">
                      In the event of a merger, acquisition, or sale of assets, your information may
                      be transferred to the acquiring entity, subject to the same privacy
                      protections.
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">With Your Consent</h3>
                    <p className="text-sm text-gray-700">
                      We may share information with third parties when you have given us explicit
                      permission to do so.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-lock-line text-orange-600 mr-3"></i>
                  Data Security
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  We implement appropriate technical and organizational security measures to protect
                  your information against unauthorized access, alteration, disclosure, or
                  destruction. These measures include:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <i className="ri-shield-keyhole-line text-orange-600 text-2xl mb-2"></i>
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Encryption</h3>
                    <p className="text-sm text-gray-700">
                      SSL/TLS encryption for data transmission
                    </p>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <i className="ri-server-line text-orange-600 text-2xl mb-2"></i>
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Secure Storage</h3>
                    <p className="text-sm text-gray-700">
                      Protected servers and databases with access controls
                    </p>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <i className="ri-user-lock-line text-orange-600 text-2xl mb-2"></i>
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Access Control</h3>
                    <p className="text-sm text-gray-700">
                      Limited access to authorized personnel only
                    </p>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <i className="ri-refresh-line text-orange-600 text-2xl mb-2"></i>
                    <h3 className="font-bold text-gray-900 mb-2 text-sm">Regular Updates</h3>
                    <p className="text-sm text-gray-700">
                      Ongoing security audits and system updates
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-user-settings-line text-orange-600 mr-3"></i>
                  Your Rights and Choices
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  You have the following rights regarding your personal information:
                </p>
                <div className="bg-gray-50 rounded-lg p-6">
                  <ul className="space-y-3 text-sm text-gray-700">
                    <li className="flex items-start">
                      <strong className="text-orange-600 mr-2 min-w-[80px]">Access:</strong>
                      <span>Request access to the personal information we hold about you</span>
                    </li>
                    <li className="flex items-start">
                      <strong className="text-orange-600 mr-2 min-w-[80px]">Correction:</strong>
                      <span>Request correction of inaccurate or incomplete information</span>
                    </li>
                    <li className="flex items-start">
                      <strong className="text-orange-600 mr-2 min-w-[80px]">Deletion:</strong>
                      <span>
                        Request deletion of your personal information, subject to legal obligations
                      </span>
                    </li>
                    <li className="flex items-start">
                      <strong className="text-orange-600 mr-2 min-w-[80px]">Opt-Out:</strong>
                      <span>
                        Unsubscribe from marketing communications at any time using the unsubscribe
                        link in our emails
                      </span>
                    </li>
                    <li className="flex items-start">
                      <strong className="text-orange-600 mr-2 min-w-[80px]">Portability:</strong>
                      <span>Request a copy of your data in a portable format</span>
                    </li>
                  </ul>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed mt-4">
                  To exercise any of these rights, please contact us at{' '}
                  <a
                    href="mailto:domination@thompsondigital.org"
                    className="text-orange-600 hover:text-orange-700 font-medium"
                  >
                    domination@thompsondigital.org
                  </a>
                  .
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-cookie-line text-orange-600 mr-3"></i>
                  Cookies and Tracking Technologies
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  We use cookies and similar tracking technologies to enhance your experience on our
                  website. Cookies are small data files stored on your device that help us:
                </p>
                <ul className="space-y-2 text-sm text-gray-700 mb-4">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                    <span>Remember your preferences and settings</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                    <span>Understand how you use our website</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                    <span>Improve our services and user experience</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                    <span>Deliver relevant advertising</span>
                  </li>
                </ul>
                <p className="text-sm text-gray-700 leading-relaxed">
                  You can control cookies through your browser settings. However, disabling cookies
                  may affect the functionality of our website.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-time-line text-orange-600 mr-3"></i>
                  Data Retention
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed">
                  We retain your personal information for as long as necessary to fulfill the
                  purposes outlined in this policy, unless a longer retention period is required or
                  permitted by law. When we no longer need your information, we will securely delete
                  or anonymize it.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-parent-line text-orange-600 mr-3"></i>
                  Children's Privacy
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Our services are not directed to individuals under the age of 18. We do not
                  knowingly collect personal information from children. If you believe we have
                  inadvertently collected information from a child, please contact us immediately.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-links-line text-orange-600 mr-3"></i>
                  Third-Party Links
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Our website may contain links to third-party websites. We are not responsible for
                  the privacy practices or content of these external sites. We encourage you to
                  review the privacy policies of any third-party sites you visit.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-refresh-line text-orange-600 mr-3"></i>
                  Changes to This Policy
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed">
                  We may update this Privacy & Confidentiality Policy from time to time to reflect
                  changes in our practices or legal requirements. We will notify you of any material
                  changes by posting the updated policy on our website with a new "Last Updated"
                  date. Your continued use of our services after such changes constitutes acceptance
                  of the updated policy.
                </p>
              </div>

              <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-xl p-8 text-white">
                <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
                <p className="text-sm mb-6 leading-relaxed">
                  If you have any questions, concerns, or requests regarding this Privacy &
                  Confidentiality Policy or our data practices, please contact us:
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-building-line text-xl mr-3 mt-0.5"></i>
                    <div>
                      <div className="font-semibold mb-1">Digital Domination LLC</div>
                      <div className="text-sm">8025 Tank Loop St, Las Vegas, NV 89166</div>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-mail-line text-xl mr-3"></i>
                    <a
                      href="mailto:domination@thompsondigital.org"
                      className="text-sm hover:underline"
                    >
                      domination@thompsondigital.org
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-phone-line text-xl mr-3"></i>
                    <a href="tel:+17252756972" className="text-sm hover:underline">
                      +1 (725) 275-6972
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
